function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "group0",
  transform: "matrix(0.00482575835265133 0 0 0.00422253855856991 0 -0.0747811578722721)",
  fill: "none"
}, React.createElement("g", {
  id: "group1",
  fill: "none"
}, React.createElement("path", {
  id: "shape0",
  transform: "translate(0, 102.403000000001)",
  fill: "currentColor",
  d: "M512 285.267L405.406 178.621L405.406 263.315L394.971 263.315C326.819 263.315 292.51 207.169 252.78 142.158C212.06 75.525 165.905 0 73.143 0L0 0L0 43.886L73.143 43.886C141.295 43.886 175.604 100.032 215.334 165.043C256.054 231.676 302.209 307.201 394.971 307.201L405.406 307.201L405.406 391.887Z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "group2",
  transform: "matrix(0.00482575835265133 0 0 0.00422253855856991 0 -0.0747811578722721)",
  fill: "none"
}, React.createElement("g", {
  id: "group3",
  fill: "none"
}, React.createElement("path", {
  id: "shape1",
  transform: "translate(251.836, 17.7099999999998)",
  fill: "currentColor",
  d: "M260.164 106.645L153.57 0L153.57 84.695L143.135 84.695C76.421 84.695 33.816 123.758 0 170.483C9.055 184.067 17.433 197.732 25.391 210.751C56.415 163.806 89.161 128.579 143.135 128.579L153.57 128.579L153.57 213.265Z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "group4",
  transform: "matrix(0.0045 0 0 0.0039375 0 0)",
  fill: "none"
}, React.createElement("g", {
  id: "group5",
  fill: "none"
}, React.createElement("path", {
  id: "shape2",
  transform: "translate(0, 283.548000000005)",
  fill: "currentColor",
  d: "M190.887 0C159.863 46.943 127.117 82.17 73.143 82.17L0 82.17L0 126.056L73.143 126.056C139.857 126.056 182.462 86.993 216.278 40.268C207.222 26.684 198.845 13.019 190.887 0Z"
})));

var SvgShuffle = function SvgShuffle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "2.304pt",
    height: "2.016pt",
    viewBox: "0 0 2.304 2.016",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShuffle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shuffle.a659edc5.svg";
export { ForwardRef as ReactComponent };